import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  id: "DuplicateAlertReasonModal"
}
const _hoisted_2 = { class: "DuplicateAlertReasonContentBlock" }
const _hoisted_3 = { class: "DuplicateAlertReasonTitle" }
const _hoisted_4 = {
  ref: "duplicateAlertReasonDescription",
  class: "Textarea Note DuplicateAlertReasonDescription"
}
const _hoisted_5 = { class: "DuplicateAlertReasonButtonWrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "DuplicateAlertReasonHeaderBlock" }, [
      _createElementVNode("h3", null, "Enrolment details")
    ], -1 /* CACHED */)),
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, " Please enter the reason for marking " + _toDisplayString(_ctx.textPresenter.theseEnrolmentsDisplayText) + " as \"" + _toDisplayString(_ctx.markedAsDuplicated ? 'Duplicated' : 'Not duplicated') + "\". ", 1 /* TEXT */),
      _createElementVNode("textarea", _hoisted_4, null, 512 /* NEED_PATCH */),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("input", {
          type: "submit",
          class: "DriverButton",
          value: "Continue",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.continueToConfirmationScreen && _ctx.continueToConfirmationScreen(...args))),
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, null, 32 /* NEED_HYDRATION */)
      ])
    ])
  ], 512 /* NEED_PATCH */))
}